<template>
        <div class="page">
                <basic-container style="min-width:300px;flex-shrink: 0;flex-grow: 0;">
                       <div>   
                               项目名称
                                <el-select v-model="projectId"
                                        @change="changeProject"
                                 placeholder="请选择">
                                        <el-option
                                                v-for="item in projectList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                                </el-option>
                                </el-select>
                       </div>
                       <div style="margin:20px;text-align:center;">
                               <el-button :type="type==1?'primary':''"  @click="changeType(1)">按仪表</el-button>
                               <el-button :type="type==2?'primary':''" @click="changeType(2)">按科室</el-button>
                               
                       </div>
                       <div>
                               <el-input
                                        placeholder="输入关键字进行过滤"
                                        v-model="filterText">
                                </el-input>
                               <el-tree

                                        v-show="type==1"
                                        :data="meterTreeTreeData"
                                        :props="meterDefaultProps"
                                        @node-click="treeNodeClickMeter"
                                        :filter-node-method="filterNodeMeter"
                                        ref="tree">
                                </el-tree>
                                <el-tree

                                        v-show="type==2"
                                        :data="deptTreeData"
                                        :props="deptDefaultProps"
                                        @node-click="treeNodeClickDept"
                                        :filter-node-method="filterNodeDept"
                                        ref="treeDept">
                                </el-tree>
                       </div>
                </basic-container>
                <div style="flex-shrink: 1;flex-grow: 1;display: flex;flex-direction: column;height:100%;">
                        <basic-container style="margin-top:-10px;flex-shrink: 0;flex-grow: 0;"> 
                                <div style="margin:20px;">
                                        时间
                                        <el-date-picker
                                        style="margin-left:10px;"
                                                v-model="statisticsTime"
                                                type="month"
                                                @change="changeTime"
                                               
                                                placeholder="选择月">
                                        </el-date-picker>
                                </div>
                        </basic-container>
                        <basic-container style="margin-top:-10px;flex-shrink: 0;flex-grow: 0;"> 
                                <div style="font-size:18px;color:#333;font-weight:600;">
                                        趋势图
                                </div>
                                <el-divider></el-divider>
                                <div>
                                        <div id="main" style="width:100%;height:400px;"></div>
                                </div>
                        </basic-container>
                        <basic-container style="margin-top:-10px;flex-shrink: 0;flex-grow: 0;"> 
                                <div style="display:flex;justify-content:space-between;">
                                        <div class="trend-chart-title-left">
                                                表格统计
                                        </div>
                                        <div style="flex-shrink: 1;flex-grow: 2;" class="trend-chart-title">
                                                <span class="sapn1">单价:kWh</span>
                                                <span class="sapn2">
                                                        <div style="height:16px;width:16px;background-color:#FF7E00;"></div>
                                                        <span>最大值</span>
                                                </span>
                                                <span class="sapn3">
                                                        <div style="height:16px;width:16px;background-color:#409EFF;"></div>
                                                        <span>最小值</span>
                                                </span>
                                                <span class="sapn4">
                                                        <el-button size="small">
                                                                导 出
                                                        </el-button>
                                                </span>
                                        </div>
                                </div>
                                <div class="tabel">
                                        <table style="width:100%;" border="1">
                                                <thead>
                                                        <th>时间</th>
                                                        <th>用电量</th>
                                                </thead>
                                                <tbody>
                                                        <tr v-for=" item in  tabelData" :key="item">
                                                                <td>{{dayjs(item.statisticsTime).format('YYYY-MM-DD')}}</td>
                                                                <td>
                                                                        <span v-if="item.min" style="color:#409EFF">
                                                                                  {{item.statisticsNum}}
                                                                        </span>
                                                                        <span v-else-if="item.max" style="color:#FF7E00">
                                                                                  {{item.statisticsNum}}
                                                                        </span>
                                                                        <span v-else>
                                                                                  {{item.statisticsNum}}
                                                                        </span>
                                                                      
                                                                </td>
                                                        </tr>
                                                </tbody>
                                        </table>
                                </div>
                                
                                
                        </basic-container>
                </div>
                
        </div>
</template>
<script>
import * as echarts from 'echarts';
import {
       getProjectList,//项目
       meterTree,//仪表树
       treeByProjectDeptId,//科室树
       getEnergyStatisticsElectDeptDayOneMonthInfo,
       getEnergyStatisticsElectMeterOneMonthInfo,
}from "@/api/crmedical/energy/use-electricity/index.js"
export default {
        data(){
   
                 return{
                        statisticsTime:'',
                        type:1,
                        projectId:'',
                        projectList:[],
                        filterText:'',
                        meterType:'',
                        deptId:'',
                        meterTreeTreeData:[],
                        deptTreeData:[],
                        tabelData:[],
                        meterDefaultProps: {
                                children: 'children',
                                label: 'meterName'
                        },
                        deptDefaultProps: {
                                children: 'children',
                                label: 'title'
                        },
                        myChart:'',
      
                }
        },
        created(){
                this.initData();
        },
        watch: {
                filterText(val) {
                        if(this.type==1){
                                this.$refs.tree.filter(val);
                        }else{
                                this.$refs.treeDept.filter(val);
                        }
                        
                }
        },
        methods:{
                async initData(){
                        this.statisticsTime = new Date();
                        await getProjectList().then(({data})=>{
                                console.log(12321321)
                                this.projectList = data;
                                this.projectId = data[0]?data[0].id:'';
                                this.getMeterTree(this.projectId);
                        })
                },
                // 点击仪表树节点
                treeNodeClickMeter(node,key,value){
                        if(this.meterType==node.id) return;
                        this.meterType = node.id;
                        this.getEnergyStatisticsElectMeterOneMonthInfo();
                },
                // 点击科室树节点
                treeNodeClickDept(node,key,value){
                        if(this.deptId==node.id) return;
                        this.deptId = node.id;
                        this.getEnergyStatisticsElectDeptDayOneMonthInfo();
                },
                // 根据科室获得能耗数据
                getEnergyStatisticsElectDeptDayOneMonthInfo(){
                        this.statisticsTime = this.dayjs(this.statisticsTime).format('YYYY-MM-01 00:00:00');
                        getEnergyStatisticsElectDeptDayOneMonthInfo(
                                {
                                        projectId:this.projectId,
                                        deptId:this.deptId,
                                        statisticsTime:this.statisticsTime
                                }
                                ).then((data)=>{
                                        let lineOption = {
                                                xAxisData:[],
                                                seriesData:[],
                                        }
                                        data.data.forEach(ele=>{
                                                lineOption.xAxisData.push(ele.label);
                                                lineOption.seriesData.push(ele.statisticsNum);
                                        })
                                        this.tabelData = data.data;
                                        this.renderLineChar(lineOption);

                        })
                },
                 // 根据仪表获得能耗数据
                getEnergyStatisticsElectMeterOneMonthInfo(){
                        this.statisticsTime = this.dayjs(this.statisticsTime).format('YYYY-MM-01 00:00:00');
                        getEnergyStatisticsElectMeterOneMonthInfo(
                                {
                                        projectId:this.projectId,
                                        meterId:this.meterType,
                                        statisticsTime:this.statisticsTime
                                }
                                ).then((data)=>{
                                        console.log(data)
                                        let lineOption = {
                                                xAxisData:[],
                                                seriesData:[],
                                        }
                                        data.data.forEach(ele=>{
                                                lineOption.xAxisData.push(ele.label);
                                                lineOption.seriesData.push(ele.statisticsNum);
                                        })
                                        this.tabelData = data.data;
                                        this.renderLineChar(lineOption);

                        })
                },
                // 获取仪表树
                getMeterTree(projectId){
                        meterTree({projectId:projectId||this.projectId}).then(({data})=>{
                                this.meterTreeTreeData = data;
                        })
                },
                // 获取科室树
                treeByProjectDeptId(projectId){
                        treeByProjectDeptId({projectId:projectId||this.projectId}).then(({data})=>{
                                this.deptTreeData = data;
                                console.log(this.deptTreeData)
                        })
                },
                filterNodeMeter(value, data) {
                        if (!value) return true;
                        console.log(data)
                        return data.meterName.indexOf(value) !== -1;
                },
                // 科室树的赛选
                filterNodeDept(value, data) {
                        if (!value) return true;
                        console.log(data)
                        return data.title.indexOf(value) !== -1;
                },
                // 切换时间
                changeTime(val){
                        console.log(val)
                        this.statisticsTime = val;
                        if(!this.projectId){
                                return;
                        }
                        if(this.type==1 && this.meterType){
                                this.getEnergyStatisticsElectMeterOneMonthInfo();
                        }else if(this.type==2 && this.deptId){
                                this.getEnergyStatisticsElectDeptDayOneMonthInfo()
                        }else{
                                return;
                        }
                },
                // 切换仪表 科室 视角
                changeType(val){
                        if(this.type==val){
                                return;
                        }else{
                                if(val==1){
                                        if(this.meterTreeTreeData.length<1){
                                                this.getMeterTree();
                                        }
                                }else{
                                        if(this.deptTreeData.length<1){
                                                this.treeByProjectDeptId();
                                        }
                                }
                                this.filterText = '';
                                this.meterType = '';
                                this.deptId = '';
                                this.type = val;

                        }
                        
                },
                // 切换项目
                changeProject(val){
                        console.log(val)
                        this.filterText = '';
                        this.meterType = '';
                        this.deptId = '';
                        this.tabelData = [];
                        if(this.type==1){
                                this.getMeterTree();
                        }else{
                                this.treeByProjectDeptId()
                        }
                        this.renderLineChar({});
                },
                // 渲染统计图
                renderLineChar(data){
                        
                        if(data.xAxisData && data.xAxisData.length<1){
                                data.xAxisData = false;
                        }
                        if(data.seriesData && data.seriesData.length<1){
                                data.seriesData = false;
                        }

                        let option = {
                        tooltip:{
                                show: true,
                                trigger: 'axis',
                                showDelay: 0,//显示延时，添加显示延时可以避免频繁切换
                                transitionDuration: 0,//动画变换时长
                                backgroundColor: 'rgba(255,255,255,0.9)',//背景颜色（此时为默认色）
                                borderRadius: 8,//边框圆角
                                padding: 10,    // [5, 10, 15, 20] 内边距
                                position: function (p) {
                                        // 位置回调
                                        // console.log && console.log(p);
                                        return [p[0] + 10, p[1] - 10];
                                },
                                formatter: function (params, ticket, callback) {
                                console.log(params)
                                var res = `
                                        <div style="display:flex;justify-content:space-between;width:130px;height:60px;">
                                                <span>用电量</span>
                                                <span>${params[0].data}kWh</span>
                                        </div>
                                `

                                setTimeout(function () {
                                // 仅为了模拟异步回调
                                callback(ticket, res);
                                }, 10)
                                return 'loading...';
                        },
                        },
                        xAxis: {
                                type: 'category',
                                nameLocation: 'middle',
                                data: data.xAxisData || ['1', '2', '3', '4', '5', '6', '7',8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
                                // ['1', '2', '3', '4', '5', '6', '7',8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                        },
                        yAxis: {
                                type: 'value'
                        },
                        series: [{
                                data: data.seriesData || [0],
                                // [150, 230, 224, 218, 135, 147, 260,150, 230, 224, 218, 135, 147, 260,150, 230, 224, 218, 135, 147, 260,150, 230, 224, 218, 135, 147, 260],
                                type: 'line'
                        }]
                        };

                        this.myChart.setOption(option);
                }
                // 渲染表格内容
                
        },
        mounted(){
                var chartDom = document.getElementById('main');
                this.myChart = echarts.init(chartDom);
                this.renderLineChar({});
        },
             
}
</script>

<style lang="scss" scoped>
.page{
        display: flex;
        
        width: 100%;
        
        
}
.trend-chart-title-left{
        font-size:18px;
        color:#333;
        font-weight:600;
        flex-shrink: 0;
        flex-grow: 0;
        width:200px;
        position: relative;
                top: 3px;

}

.trend-chart-title{
        display: flex;
        justify-content: flex-end;
        span{
                margin: 0 10px;
                font-weight: 600;
                color: #333
        }
        .sapn1{
                position: relative;
                top: 3px;
        }
        .sapn2{
                // font: ;
                display: flex;
                align-items: center;
        }
        .sapn3{
                // font: ;
                 display: flex;
                 align-items: center;
        }
}
.tabel{
        width: 100%;
        margin: 30px 0;
        th{
                background-color: #F2F2F2;
                height: 40px;
                line-height: 40px;
        }
        td{
                height: 40px;
                line-height: 40px;
                text-align: center;
        }
}
</style>